import React from 'react';
import { FormattedMessage } from 'react-intl';

import useAboutStyles from './aboutStyles';
import { cx } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_TINTS } from '../../constants';

const IMG = '/static/asset/img/';

const PARTNERS = [
    {
        key: 'samsung',
        titleId: 'aboutUs.partners.samsung',
        texts: [
            'aboutUs.partners.samsung.description',
            'aboutUs.partners.samsung.description1',
            'aboutUs.partners.samsung.description2',
        ],
        links: [
            {
                labelId: 'aboutUs.partners.samsung.announcement',
                href: 'https://www.edupedu.ro/video-profesorul-controleaza-interactivitatea-cu-elevul-ghideaza-clasa-spune-marius-mazilu-fondatorul-vboard-aplicatia-nativa-pe-tablele-interactive-nu-ne-permitem-ca-procesul-educational-sa-ias/',
            },
        ],
        logos: [{ src: `${IMG}samsung.png`, alt: 'Samsung' }],
        tint: REDESIGN_TINTS.sky,
    },
    {
        key: 'microsoft',
        titleId: 'aboutUs.partners.microsoft',
        texts: ['aboutUs.partners.microsoft.description'],
        links: [
            {
                labelId: 'aboutUs.partners.microsoft.teamsStore',
                href: 'https://appsource.microsoft.com/en-us/product/office/WA200004360?tab=Overview',
            },
        ],
        logos: [
            { src: `${IMG}MicrosoftLogo.png`, alt: 'Microsoft' },
            { src: `${IMG}MicrosoftTeamsLogo.png`, alt: 'Microsoft Teams' },
        ],
        tint: REDESIGN_TINTS.periwinkle,
    },
    {
        key: 'orange',
        titleId: 'aboutUs.partners.orange',
        texts: ['aboutUs.partners.orange.description'],
        links: [
            {
                labelId: 'aboutUs.partners.orangeFab',
                href: 'https://www.orangefab.ro/vboard-orange-fab-startups-that-supports-online-education/',
            },
        ],
        logos: [{ src: `${IMG}OrangeFab.png`, alt: 'Orange Fab' }],
        tint: REDESIGN_TINTS.peach,
    },
    {
        key: 'innolabs',
        titleId: 'aboutUs.partners.innolabs',
        texts: ['aboutUs.partners.innolabs.description'],
        links: [
            {
                labelId: 'aboutUs.partners.innolabs.awards',
                href: 'https://www.facebook.com/watch/live/?ref=watch_permalink&v=329145398984969&t=14836',
            },
        ],
        logos: [{ src: `${IMG}InnovationLabs.png`, alt: 'Innovation Labs' }],
        tint: REDESIGN_TINTS.mint,
    },
];

const AboutPartners = () => {
    const classes = useAboutStyles();

    return (
        <>
            <div className={classes.head}>
                <h2 className={classes.h2}>
                    <FormattedMessage id="aboutUs.partners.button" />
                </h2>
                <p className={classes.lead}>
                    <FormattedMessage id="redesign.about.partners.lead" />
                </p>
            </div>

            {PARTNERS.map((partner, index) => (
                <article key={partner.key} className={classes.card}>
                    <div className={cx(classes.row, index % 2 === 1 && classes.rowFlipped)}>
                        <div>
                            <h3 className={classes.h3}>
                                <FormattedMessage id={partner.titleId} />
                            </h3>
                            {partner.texts.map((id) => (
                                <p key={id} className={classes.text}>
                                    <FormattedMessage id={id} />
                                </p>
                            ))}
                            <div className={classes.links}>
                                {partner.links.map((link) => (
                                    <a
                                        key={link.href}
                                        href={link.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={classes.external}
                                    >
                                        <FormattedMessage id={link.labelId} />
                                        <span aria-hidden="true">↗</span>
                                    </a>
                                ))}
                            </div>
                        </div>
                        <div className={classes.mat} style={{ background: partner.tint, gap: '16px' }}>
                            {partner.logos.map((logo) => (
                                <img
                                    key={logo.src}
                                    src={logo.src}
                                    alt={logo.alt}
                                    loading="lazy"
                                    decoding="async"
                                    className={classes.logo}
                                />
                            ))}
                        </div>
                    </div>
                </article>
            ))}
        </>
    );
};

export default AboutPartners;
